/* store all the provider files */
/* allows to use the redux extension in chrome */
                                                                                    // import { createStore, combineReducers, applyMiddleware , compose } from 'redux';
import { createStore, combineReducers, applyMiddleware } from 'redux';
                                                                                    // import logger from "redux-logger"; // for dev purposes only
import thunk from 'redux-thunk';
import promise from "redux-promise-middleware/src";
import {
    GET_ARCHIVED_REFERRAL_PENDING,
    GET_ARCHIVED_CLIENT_PENDING,
    GET_ARCHIVED_POSTDISCHARGE_PENDING,
    GET_REFERRAL_PENDING,
    GET_CLIENT_PENDING,
    GET_POSTDISCHARGE_PENDING,
    UPDATE_REFERRAL_SAVE_AND_CLOSE_FULFILLED,
    UPDATE_CLIENT_SAVE_AND_CLOSE_FULFILLED,
    UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_FULFILLED,
} from 'actions/action-constants';
import {
                                                            // CHANGE_PASSWORD_PENDING,
                                                            // CHANGE_PASSWORD_FULFILLED,
  UPDATE_LOGIN_FULFILLED,
  GET_LOGINS_LIST_PENDING,
} from 'components/module-login/actions/action-constants';

/*** redux-forms */
import {reducer as formReducer } from 'redux-form'; /* redux-forms */
/*** you can import them as whatever name you want */



/*** module-login reducers --- START */
/*** you can import them as whatever name you want */
import authR from 'components/module-login/redux/reducer-auth';
import loginsR from 'components/module-login/redux/reducer-logins';
import loginrolesR from 'components/module-login/redux/reducer-login-roles';
/*** module-login reducers --- END */

import reportsR from './reducers/reducer-reports';
import globalsR from './reducers/reducer-globals';
import reportsGlobalsR from './reducers/reducer-reports-globals';

import referralsR from './reducers/reducer-referrals';
import archivedreferralsR from './reducers/reducer-archived-referrals';
import clientsR from './reducers/reducer-clients';
import archivedclientsR from './reducers/reducer-archived-clients';
import postdischargesR from './reducers/reducer-postdischarges';
import archivedpostdischargesR from './reducers/reducer-archived-postdischarges';
import programsR from './reducers/reducer-programs';
import referraloutcomesR from './reducers/reducer-referral-outcomes';
import alchoholaftercareprogramsR from './reducers/reducer-alchohol-aftercare-programs';
                                              import bhtsinsuranceprovidersR from './reducers/reducer-bhts-insurance-providers';
import bopinstitutionsR from './reducers/reducer-bop-institutions';
import drugaftercareprogramsR from './reducers/reducer-drug-aftercare-programs';
import financialresponsibilityprogramR from './reducers/reducer-financial-responsibility-programs';
import gangaffiliationsR from './reducers/reducer-gang-affiliations';
import levelsofsecurityR from './reducers/reducer-levels-of-securitys';
import referralsourcesR from './reducers/reducer-referral-sources';



                                                                                                                  /* save data to localStorage and load the data if it already exists if not create empty object like above ... */
                                                                                                                  // const initialState = (localStorage['redux-store']) ?
                                                                                                                  //     JSON.parse(localStorage['redux-store']) :
                                                                                                                  //     {};


                                                                                                                  // const initialState = {
                                                                                                                  //     isAuthenticated: false
                                                                                                                  //     , isAuthenticating: true
                                                                                                                  // };

/*
    1st is the root reducer of all the reducers
    2nd initial state of the app
    3rd add any enhancers in this case the following 
*/
const store = createStore( 
    combineReducers({
      /*** module-login reducers --- START */
        auth: authR,
        logins: loginsR,
        loginroles: loginrolesR,
      /*** module-login reducers --- END */



        
        globalsR,

        reportsR,
        reportsGlobalsR,

        referralsR,
        archivedreferralsR,
        clientsR,
        archivedclientsR,
        postdischargesR,
        archivedpostdischargesR,
        programsR,
        referraloutcomesR,
        alchoholaftercareprogramsR,
                                                    bhtsinsuranceprovidersR,
        bopinstitutionsR,
        drugaftercareprogramsR,
        financialresponsibilityprogramR,
        gangaffiliationsR,
        levelsofsecurityR,
        referralsourcesR,


        /***
         * redux-forms 
         * clear form before and after loading the pulled data 
        */
        form: formReducer.plugin({
            ReferralEditForm: (state, action) => { // <------ form name given to reduxForm()
              switch(action.type) {
                case GET_ARCHIVED_REFERRAL_PENDING:
                case GET_REFERRAL_PENDING:
                  return undefined;       // <--- blow away form data
                case UPDATE_REFERRAL_SAVE_AND_CLOSE_FULFILLED:
                  return undefined;       // <--- blow away form data
                default:
                  return state;
              }
            },
            ClientEditForm: (state, action) => {
              switch(action.type) {
                case GET_ARCHIVED_CLIENT_PENDING:
                case GET_CLIENT_PENDING:
                  return undefined;
                case UPDATE_CLIENT_SAVE_AND_CLOSE_FULFILLED:
                  return undefined;
                default:
                  return state;
              }
            },
            PostDischargeEditForm: (state, action) => {
              switch(action.type) {
                case GET_ARCHIVED_POSTDISCHARGE_PENDING:
                case GET_POSTDISCHARGE_PENDING:
                  return undefined;
                case UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_FULFILLED:
                  return undefined;
                default:
                  return state;
              }
            },
            LoginForm: (state, action) => {
              switch(action.type) {
                case GET_LOGINS_LIST_PENDING:
                                                                                      // console.log('9975 - Clear LoginForm Form' );
                  return undefined;
                case UPDATE_LOGIN_FULFILLED:
                                                                                      // console.log('9976 - Clear LoginForm Form' );
                  return undefined;
                default:
                                                                                      // console.log('9977 - DO NOT - - - Clear LoginForm Form' );
                  return state;
              }
            },
                                                      //   PasswordResetForm: (state, action) => {
                                                      //     switch(action.type) {
                                                      //       case CHANGE_PASSWORD_PENDING:
                                                      //         return undefined;
                                                      //       case CHANGE_PASSWORD_FULFILLED:
                                                      //         return undefined;
                                                      //       default:
                                                      //         return state;
                                                      //     }
                                                      //   },
      }),

    })
    , {} /* initialState */
                                                                                      // , initialState
    /* thunk added for async calls in the action files as they take a
     long time to execut this allows the app to continue to run and 
     wait for a response and not work 1 functino at a time */
    , applyMiddleware(
        thunk
        , promise
                                                                                      // , logger // remove after dev this is not for production logs everything
                                                                                      // , middleWare
                                                                                      // impliment the redux dev tools
                                                                                      // , window.__REDUX_DEVTOOLS_EXTENSION__&& window.__REDUX_DEVTOOLS_EXTENSION__()
                                                                                      // , window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__&& window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
                                                                                      // , window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__() || compose
    ) 
);

                                                                                      /* 
                                                                                      for dev purposes only to see how the store changed 
                                                                                      this allows you to console out everytime the state changes, once for every action you invoke
                                                                                      */
                                                                                      // store.subscribe(() => {
                                                                                      //     console.log("KOT - 4444-101-store updated! : " , store.getState() )
                                                                                      // });
                                                                                      // store.subscribe(() => console.log("KOT 4444 - STORE CHANGE : ", store.getState() ));

                                                                                      // /* open console in browser - type in localStorage and hit enter to see what is stored here */
                                                                                      // store.subscribe(() => {
                                                                                      //     const state = JSON.stringify(store.getState() )
                                                                                      //     localStorage['redux-store'] = state
                                                                                      // });

                                                                                      // /* globally expose the store */
                                                                                      // window.store = store;

export default store;

                                                                                      /*
                                                                                      lesson
                                                                                      3.1 - setting up the webpack file that you will need
                                                                                      3.2 - creating a dispatch and the payload
                                                                                      3.3 - localStore setup and etc....
                                                                                      */
